module.exports = __webpack_public_path__ + "static/media/why-3_.eb8e7829.jpg";